(() => {
  const fields = ['title', 'body', 'tag', 'variants.sku', 'variants.barcode', 'vendor', 'product_type'];
  const scope = (value) => {
    const clean = value.trim().replace(/^"|"$/g, '').replace(/[\\"]/g, '\\$&');
    return fields.map((field) => field + ':"' + clean + '"').join(' OR ');
  };
  const escapeHtml = (value) => value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  const isSearch = (url) => /\/search(?:\/suggest(?:\.json)?)?$/.test(url.pathname);
  const prepare = (url) => {
    const query = url.searchParams.get('q');
    if (!query) return url;
    if (/\/search\/suggest(?:\.json)?$/.test(url.pathname)) {
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      return url;
    }
    const raw = url.searchParams.get('dcr_q');
    if (raw) {
      url.searchParams.set('q', scope(raw));
      return url;
    }
    url.searchParams.set('dcr_q', query);
    url.searchParams.set('q', scope(query));
    return url;
  };
  const current = new URL(location.href);
  if (/\/search$/.test(current.pathname) && current.searchParams.get('q') && !current.searchParams.has('dcr_q')) {
    location.replace(prepare(current).href);
    return;
  }
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    if (typeof input !== 'string' && !(input instanceof URL)) return nativeFetch(input, init);
    const url = new URL(input, location.href);
    if (url.origin !== location.origin || !isSearch(url)) return nativeFetch(input, init);
    prepare(url);
    const response = await nativeFetch(url.href, init);
    const raw = url.searchParams.get('dcr_q');
    const scoped = url.searchParams.get('q');
    if (!raw || !response.headers.get('content-type')?.includes('text/html')) return response;
    const html = await response.text();
    const rewritten = html.split(escapeHtml(scoped)).join(escapeHtml(raw));
    const headers = new Headers(response.headers);
    headers.delete('content-length');
    return new Response(rewritten, {status: response.status, statusText: response.statusText, headers});
  };
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.href);
    if (!/\/search$/.test(url.pathname)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input?.value.trim()) return;
    event.preventDefault();
    const data = new FormData(form);
    url.search = new URLSearchParams(data).toString();
    url.searchParams.delete('dcr_q');
    prepare(url);
    location.assign(url.href);
  }, true);
  const restore = () => {
    const raw = current.searchParams.get('dcr_q');
    const scoped = current.searchParams.get('q');
    if (!raw || !scoped) return;
    document.querySelectorAll('input[name="q"]').forEach((input) => {input.value = raw;});
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (['SCRIPT', 'STYLE'].includes(node.parentElement?.tagName)) continue;
      if (node.nodeValue.includes(scoped)) node.nodeValue = node.nodeValue.split(scoped).join(raw);
    }
    document.title = document.title.split(scoped).join(raw);
  };
  document.addEventListener('DOMContentLoaded', restore);
})();
